/* eslint-disable comma-dangle */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  Alert, 
  AlertTitle,
  Button,
  Chip,
  TextField,
  Select,
  MenuItem,
  Paper,
  Typography,
  Tooltip,
  Checkbox,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Modal,
  Tab,
  Tabs,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText
} from "@mui/material";
import {
  Lock,
  ExpandMore,
  Help,
} from '@mui/icons-material';
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import TableAbstraction from "../../componentUtils/TableAbstraction";
import {checkForRole} from "../../utils/GetAuth";

import AdminReconciliation from "./AdminReconciliation";
import AdminMaterialReconciliation from "./AdminMaterialReconciliation";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      margin: '0',
      position: 'absolute',
      top: '50%',
      left: '50%'
    },
    root: {
      margin: '0',
      padding:'0'

    },
    divWidth: {
      width: "100%"
    },
    gridSpaceable: {
      padding: theme.spacing(2)
    },
    gridMarginTop: {
      marginTop: theme.spacing(2)
    },
    paragraph: {
      padding: theme.spacing(1)
    },
    paragraphAct: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #000',
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2)
    },
    checkbox: {
      padding: 0,
      "&$disabled": {
        color: theme.palette.primary.main
      }
    },
    navtab: {
      //backgroundColor: theme.palette.grey[100],
    },
    navtabsel: {
      backgroundColor: theme.palette.grey[400],
    },
    primary: {
      marginTop: theme.spacing(2)
    },
    button: {
      marginLeft: theme.spacing(2),
      minWidth: 150
    },
    
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalGrid: {
      marginTop: theme.spacing(2),
    },
    modalTitle:{
      color: theme.palette.primary.main,
    },
    modalCard: {
    },
    modalText: {
      width: 800,
    },
    modalInput: {
      paddingLeft: "2px", 
      paddingRight: "20px", 
      width:"300px"
    },
  }));

  function getModalStyle() {
    const top = 50;
    const left = 50;
  
    return {
        width: '80%',
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
  }

function LoadingSpinner(){
  return (<CircularProgress />)
}

export default function Reconciliation() {
  const classes = useStyles();
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [clientId] = useLocalStorage("SETTINGS.clientId", "100");
  const enabled = checkForRole(clientId,salesOrg,'vp_admin');
  const [codes, setCodes] = React.useState<any>();
  
  const header =  document.querySelector('ResponsiveDrawer')
  const headerAdj = header?header.clientHeight:150;
  const controlAdj = 55;
  const [TABLE_BODY_HEIGHT, setTABLE_BODY_HEIGHT] = React.useState<string>(`${window.innerHeight - headerAdj - controlAdj }px`);
  window.addEventListener('resize', ()=>{
    setTABLE_BODY_HEIGHT(`${window.innerHeight - headerAdj }px`);
  })

  const [curTab, setCurTab] = React.useState<number>(0);
  const subtabs = [
    {
      title: "Inconsistent Customer Report Data",
      content: <AdminReconciliation/>
    },
    {
      title: "Material Report Data",
      content: <AdminMaterialReconciliation/>
    }
  ];

  const handleTabsChange = (_: React.ChangeEvent<{}>, value: any) => {
    const idx = subtabs?.findIndex((v: any) => v.title === value) || 0;
    setCurTab(idx);
  };
  
  useEffect(() => {
    if (doneLoading) return;

    setDoneLoading(true);
  }, [doneLoading,salesOrg]);
  
  return (
    <div>
      {enabled ? (
        <div className={classes.root}>
          <Paper className={classes.root}>
            <Tabs
              className={classes.navtab}
              onChange={handleTabsChange}
              value={subtabs[curTab].title}
              variant="fullWidth"
            >
               {subtabs.map((tab,i) =>
                     (<Tab
                        className={(i==curTab)?classes.navtabsel:classes.navtab}
                        key={tab.title}
                        label={tab.title}
                        value={tab.title}
                     />))}
            </Tabs>
            {subtabs[curTab].content}
          </Paper>
        </div>
      ) : (
        <Alert severity="error">
          <AlertTitle><Lock/> Access Error</AlertTitle>   
          You do not currently have access to <strong>CONA Internal Support</strong> 
          activities for the <strong>{salesOrg}</strong> bottler. 
        </Alert>
      )}
    </div>
   )
}
